<div class="table-height">
    <nz-table class="main-table-header statusTable" #sortTable [nzData]="lst_Status" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Status.length > 0 || isStatusLoaded}">

        <thead>
            <tr class="tableheader">
                <!-- <th nzWidth="50px" [nzAlign]="'left'">SL#</th> -->
                <th nzWidth="110px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('invoice')">QB
                    Invoice# </th>
                <th nzWidth="170px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('name')">QB Customer
                    Name </th>
                <th nzWidth="110px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('poNumber')">PO
                    Number </th>
                <th nzWidth="120px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbshipdate')">QB
                    Ship Date </th>
                <th nzWidth="180px" [nzAlign]="'left'" [nzSortFn]="true"
                    (nzSortOrderChange)="sort('returnRequestDate')">
                    Return Request Date </th>
                <th nzWidth="130px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbpaymentstatus')">
                    QB Pmt Status</th>
                <th nzWidth="120px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbblstatus')">QB BL
                    Status </th>
                <th nzWidth="120px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbshipvia')">QB Ship
                    Via </th>
                <!-- <th nzWidth="150px" [nzAlign]="'left'">QB Delivery Phone</th> -->
                <th nzWidth="240px" [nzAlign]="'left'">Return Tracking No</th>
                <th nzWidth="150px" [nzAlign]="'center'">Action</th>
            </tr>
        </thead>

        <tbody *ngIf="lst_Status.length > 0">
            <tr *ngFor="let data of lst_Status; let i = index">
                <!-- <td [nzAlign]="'left'">{{ i + 1 }}</td> -->

                <td [nzAlign]="'center'">
                    <span>
                        <a [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+data.transactionID"
                            target="_blank">{{ data.invoiceNo }} </a>
                    </span>
                </td>

                <td [nzAlign]="'left'">{{ data.customerName }}</td>

                <td [nzAlign]="'left'">
                    <ng-container *ngIf="data.poNumber?.startsWith('WS-'); else plainText">
                        <a [href]="'https://partners.wayfair.com/d/outbound-orders/po/' + data.poNumber" target="_blank"
                            rel="noopener">
                            {{ data.poNumber }}
                        </a>
                    </ng-container>
                    <ng-template #plainText>
                        {{ data.poNumber }}
                    </ng-template>
                </td>

                <td [nzAlign]="'center'">{{ data.qB_ShipDate | date: 'MM/dd/yyyy' }}</td>
                <td [nzAlign]="'center'">{{ data.returnRequestDate | date: 'MM/dd/yyyy' }}</td>
                <td [nzAlign]="'left'">{{ data.qB_PaymentStatus }}</td>
                <!-- <td [nzAlign]="'left'">{{ data.qB_BL_Status }}</td> -->

                <td [nzAlign]="'left'" [ngStyle]="{
                                                    'background-color': data.qB_BL_Status === 'Delivered' ? '#00cc00' : 
                                                                        data.qB_BL_Status === 'InTransit' ? '#ffff4d' : 'transparent'
                                                }">
                    {{ data.qB_BL_Status }}
                </td>

                <td [nzAlign]="'left'">{{ data.qB_ShipVia }}</td>
                <!-- <td [nzAlign]="'left'">{{ data.qB_DeliveryPh }}</td> -->

                <td [nzAlign]="'left'">
                    <!-- View Mode -->
                    <div *ngIf="!data.isEditing && data.returnTrackingNumber">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <!-- Left Column: Tracking Link -->
                            <div class="ellipsis w-70">
                                <a [href]="'https://badeloft.aftership.com/' + data.returnTrackingNumber"
                                    target="_blank" rel="noopener noreferrer">
                                    {{ data.returnTrackingNumber }}
                                </a>
                            </div>

                            <!-- Right Column: Edit Button -->
                            <div>
                                <button nz-button nzType="default" (click)="editTrackingNo(data)">Edit</button>
                            </div>
                        </div>
                    </div>

                    <!-- Edit Mode -->
                    <div *ngIf="data.isEditing || !data.returnTrackingNumber">
                        <input nz-input [(ngModel)]="data.tempTrackingNo" placeholder="Enter Tracking No"
                            (focus)="onInputFocus(data)" (blur)="onInputBlur(data)" />

                        <!-- Buttons appear only when input is focused -->
                        <div *ngIf="data.showButtons" style="margin-top: 5px;">
                            <button nz-button nzType="default" (click)="updateReturnTrackingNumber(data)"
                                style="margin-right: 20px;">Save</button>
                            <button nz-button nzType="default" (click)="cancelTrackingNo(data)">Cancel</button>
                        </div>
                    </div>
                </td>

                <td [nzAlign]="'center'">
                    <!-- <button (click)="UpdateShippedReturnStatus(data.id)">Return</button> -->
                    <a (click)="$event.stopPropagation()" nz-button nzType="default" [disabled]="!data.returnTrackingNumber" nzOkText="Yes" nzCancelText="No"
                        nz-popconfirm nzPopconfirmTitle="Are you sure you want to mark this item as Back to Stock?"
                        (nzOnConfirm)="UpdateDamagedAndB2SStatus(data, true, false)" style="margin-right: 10px;">B2S</a>
                    <a (click)="$event.stopPropagation()" nz-button nzType="default" [disabled]="!data.returnTrackingNumber" nzOkText="Yes" nzCancelText="No"
                        nz-popconfirm nzPopconfirmTitle="Are you sure you want to mark this item as Damaged?"
                        (nzOnConfirm)="UpdateDamagedAndB2SStatus(data, false, true)">Damaged</a>
                </td>
            </tr>
        </tbody>

    </nz-table>
</div>